function showAddToWishListError (maxItemCountReached, fromModal) {

	const width = 560;
	const height = maxItemCountReached ? 150 : 80;
	const idSelector = maxItemCountReached ? '#sortPortfolioFull' : '#sortPortfolioGenericError';
	const errorHtml = maxItemCountReached
		? '<h1>Your Wish List is full!</h1><p>There is a 50 item limit to each wish list. You can uncheck an existing item to make room, or you can create a new wish list to hold it.</p><p>Please visit your wish list home page for more information.</p>'
		: '<h1>A site error prevented your item from being added</h1><p>Please try again.</p>';
	const errorDiv = document.createElement('div');

	errorDiv.id = idSelector.replace('#', '');
	errorDiv.classList.add('wishlistModalError');
	errorDiv.innerHTML = errorHtml;

	if (fromModal) {

		const modalContent = window.parent.document.getElementById('#lpModalContent');

		Array.from(modalContent.children).forEach((c) => c.classList.add('hidden'));

		window.parent.document.body.lpModalResize({ width, height });

		modalContent.appendChild(errorDiv);
		modalContent.getElementById(idSelector.replace('#', '')).classList.remove('hidden');

	} else {

		const { body } = document;

		body.appendChild(errorDiv);

		// lpModal is depends on jQuery (heavily)
		// TODO: refactor lpModal in vanilla JS then move to wishlist.js
		$(body).lpModal({
			onInit: true,
			width,
			height,
			content: $(idSelector),
			appendContentToForm: false
		});

	}

}

export default showAddToWishListError;
